/* import __COLOCATED_TEMPLATE__ from './remove-contact-modal.hbs'; */
import Component from '@glimmer/component';
import styles from './remove-contact-modal.module.scss';

export default class SiteDocumentsContactInfoContactsListSectionRemoveContactModal extends Component {
  styles = styles;
}
